import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = false;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public Ids:any='';  
  selectedFile:any='';
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public submitted:boolean = false;

  profileData = new FormGroup({
    f_name:new FormControl('',Validators.compose([
      Validators.required , Validators.maxLength(35)])),
    l_name:new FormControl('',Validators.compose([
      Validators.required , Validators.maxLength(35)])),
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),
  })
  
   get f() { return this.profileData.controls; }

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");  
    if(this.loginDetail.profile_image ==undefined ||  this.loginDetail.profile_image ==''){
      this.imgURL="assets/images/avatars/avatar-2.png";
    } else {
      this.imgURL=this.loginDetail.profile_image;
    }
    // this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

    getDetail(page:any){
      this.service.GetApi('/admin').subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.AllData=response.data;;
          this.dataListing= response.data.record;  
          this.totalCount = response.total; this.loading=false;
        } else {
          this.dataListing=[];  
          this.AllData=[];
          this.totalCount = response.total_record;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    updateProfile(){
      var url='/update-profile';
      let formdata=new FormData();
      let userdetail:any= this.profileData;
      if(userdetail.valid){
        formdata.append('name',userdetail.value.f_name);
        formdata.append('surname',userdetail.value.l_name);
        formdata.append('email',userdetail.value.email);
        if(this.imgURL == ''){
          this.service.dangerAlert('Please upload the image');
          this.loading=false;
          return
        } else {
          if(this.selectedFile!=''){
            formdata.append('profile',this.selectedFile);
          }
        }
        this.service.PostApiFormData(formdata,url).subscribe(((response:any)=>{
          if(response.success ==1){
            this.service.logOut();
            this.service.successAlert(response.message);
            // localStorage.setItem('gra_login',<any> JSON.stringify(response.data));
            // this.service.setSubject(response.data);
          } else {
            this.service.dangerAlert(response.message);
          }
        }))
      } else {
        return;
      }
    }

    
  getUploadFileDetail(event: any) {
    //this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.service.dangerAlert("Only images are supported.");
        return;
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
      };
    }
  }
  
  changeImage() {
    $("#file1").trigger("click");
  }
  
}
